jQuery(document).ready(function ($) {
  'use strict';

  function initHomeHeroBgSliders(context) {
	var $scope = context ? $(context) : $(document);

	$scope.find('.js-hero-bg-slider').each(function () {
	  var $slider = $(this);

	  if ($slider.hasClass('slick-initialized')) return;

	  $slider.slick({
		arrows: false,
		dots: false,
		infinite: true,
		fade: true,
		speed: 900,
		autoplay: true,
		autoplaySpeed: 5000,
		pauseOnHover: false,
		pauseOnFocus: false,
		accessibility: true,
		adaptiveHeight: false,
		draggable: false,
		swipe: false,
		touchMove: false
	  });
	});
  }

  initHomeHeroBgSliders(document);

  // Optional: re-init after AJAX/render updates
  $(document).on('sb:init-hero-sliders', function (e, container) {
	initHomeHeroBgSliders(container || document);
  });
});


// STICKY CLASSES
jQuery(document).ready(function ($) {

  function sbHeaderStates() {
	var y = $(window).scrollTop();

	// sticky after 1px
	if (y > 1) {
	  $('.mm-header').addClass('sticky');
	} else {
	  $('.mm-header').removeClass('sticky');
	}

	// thin after 150px
	if (y > 95) {
	  $('.mm-header').addClass('thin');
	} else {
	  $('.mm-header').removeClass('thin');
	}
  }

  // run once on load (handles refresh mid-page)
  sbHeaderStates();

  // run on scroll
  $(window).on('scroll', sbHeaderStates);

});


document.querySelectorAll('.quote-btn').forEach(btn => {
	btn.addEventListener('mouseenter', () => {
		document.querySelectorAll('.right-lip').forEach(el => {
			el.classList.add('right-lip-black');
		});
	});

	btn.addEventListener('mouseleave', () => {
		document.querySelectorAll('.right-lip').forEach(el => {
			el.classList.remove('right-lip-black');
		});
	});
});


// PRODUCTS
document.addEventListener('DOMContentLoaded', function () {
	if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick !== 'function') {
		return;
	}

	jQuery('.product-gallery').each(function () {
		var $gallery = jQuery(this);
		var $main = $gallery.find('.js-product-gallery-main');
		var $zoomBox = $gallery.find('.js-zoom-box');
		var $zoomBoxInner = $gallery.find('.js-zoom-box-inner');

		if (!$main.length) return;

		// MAIN SLIDER ONLY
		if (!$main.hasClass('slick-initialized')) {
			$main.slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				dots: false,
				infinite: false,
				fade: true,
				adaptiveHeight: true,
				speed: 250,
				accessibility: true,
				draggable: false
			});
		}

		function setActiveThumb(index) {
			$gallery.find('.thumb-btn').removeClass('is-active');
			$gallery.find('.thumb-btn[data-index="' + index + '"]').addClass('is-active');
		}

		function updateZoomImage() {
			var $current = $main.find('.slick-current .js-zoom-target');
			var full = $current.attr('data-full');

			if (full) {
				$zoomBoxInner.css('background-image', 'url("' + full + '")');
			}
		}

		setActiveThumb(0);
		updateZoomImage();

		// CLICK THUMB → CHANGE MAIN
		$gallery.on('click', '.thumb-btn', function (e) {
			e.preventDefault();

			var index = parseInt(this.getAttribute('data-index'), 10);

			if (!isNaN(index)) {
				$main.slick('slickGoTo', index, true);
				setActiveThumb(index);
				updateZoomImage();
			}
		});

		$main.on('afterChange', function (event, slick, currentSlide) {
			setActiveThumb(currentSlide);
			updateZoomImage();
		});

		// ZOOM
		$main.on('mouseenter', '.js-zoom-target', function () {
			if (window.innerWidth < 1200) return;

			var full = this.getAttribute('data-full');
			$zoomBoxInner.css('background-image', 'url("' + full + '")');
			$zoomBox.addClass('is-visible');
		});

		$main.on('mouseleave', '.js-zoom-target', function () {
			$zoomBox.removeClass('is-visible');
		});

		$main.on('mousemove', '.js-zoom-target', function (e) {
			if (window.innerWidth < 1200) return;

			var rect = this.getBoundingClientRect();
			var x = e.clientX - rect.left;
			var y = e.clientY - rect.top;

			var xPercent = Math.max(0, Math.min(100, (x / rect.width) * 100));
			var yPercent = Math.max(0, Math.min(100, (y / rect.height) * 100));

			$zoomBoxInner.css({
				backgroundPosition: xPercent + '% ' + yPercent + '%',
				backgroundSize: '300%'
			});
		});
	});
});



// FAQ ACCORDION
document.addEventListener('DOMContentLoaded', function () {
	const accordions = document.querySelectorAll('.js-faq-accordion');

	if (!accordions.length) return;

	accordions.forEach(function (accordion) {
		const items = accordion.querySelectorAll('.pm__faq-item');

		items.forEach(function (item) {
			const trigger = item.querySelector('.pm__faq-trigger');
			const panel = item.querySelector('.pm__faq-panel');

			if (!trigger || !panel) return;

			trigger.addEventListener('click', function () {
				const isOpen = trigger.getAttribute('aria-expanded') === 'true';

				// close all other items
				items.forEach(function (otherItem) {
					const otherTrigger = otherItem.querySelector('.pm__faq-trigger');
					const otherPanel = otherItem.querySelector('.pm__faq-panel');

					if (!otherTrigger || !otherPanel || otherItem === item) return;

					otherTrigger.setAttribute('aria-expanded', 'false');
					otherPanel.style.height = otherPanel.scrollHeight + 'px';

					requestAnimationFrame(function () {
						otherPanel.style.height = '0px';
					});

					window.setTimeout(function () {
						if (otherTrigger.getAttribute('aria-expanded') === 'false') {
							otherPanel.hidden = true;
						}
					}, 350);
				});

				// toggle current item
				if (isOpen) {
					trigger.setAttribute('aria-expanded', 'false');
					panel.style.height = panel.scrollHeight + 'px';

					requestAnimationFrame(function () {
						panel.style.height = '0px';
					});

					window.setTimeout(function () {
						if (trigger.getAttribute('aria-expanded') === 'false') {
							panel.hidden = true;
						}
					}, 350);
				} else {
					trigger.setAttribute('aria-expanded', 'true');
					panel.hidden = false;
					panel.style.height = '0px';

					requestAnimationFrame(function () {
						panel.style.height = panel.scrollHeight + 'px';
					});

					window.setTimeout(function () {
						if (trigger.getAttribute('aria-expanded') === 'true') {
							panel.style.height = 'auto';
						}
					}, 350);
				}
			});
		});
	});

	// keep open panels correct on resize
	window.addEventListener('resize', function () {
		document.querySelectorAll('.js-faq-accordion .pm__faq-trigger[aria-expanded="true"]').forEach(function (trigger) {
			const panel = document.getElementById(trigger.getAttribute('aria-controls'));
			if (panel) {
				panel.hidden = false;
				panel.style.height = 'auto';
			}
		});
	});
});


// FULL IMAGE SLIDER
document.addEventListener('DOMContentLoaded', function () {
	if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

	jQuery('.js-accessible-image-slider').each(function () {
		const $slider = jQuery(this);

		if ($slider.hasClass('slick-initialized')) return;

		$slider.slick({
			accessibility: true,
			adaptiveHeight: true, // <-- this is the change
			arrows: false,
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: false,
			pauseOnHover: true,
			pauseOnFocus: true,
			speed: 500,
			mobileFirst: true
		});
	});
});